import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('ROIReporting');
const type = createActionType('ROIReporting');

export const OPEN_ASSET_USAGE_DIALOG = type('OpenAssetUsageDialog');
export const CLOSE_ASSET_USAGE_DIALOG = type('CloseAssetUsageDialog');
export const LOAD_TABLES_USAGE_METRICS = type('LoadTableUsageMetrics');
export const CHECK_EVENT_TABLE_ACCESS = apiType('CheckEventTableAccess');
export const SET_SELECTED_TABLE_INDEX = type('SetSelectedTableIndex');

export const SET_DATE_FILTER_AND_BIN = type('SetDateFilterAndBin');
export const RESET_FILTERS = type('ResetFilters');

export const SELECT_SPARKLINE_WINDOW = type('SelectSparklineWindow');

export const LOAD_ASSET_ROI = type('LoadAssetROI');
export const CHANGE_CHART_TYPE = type('ChangeChartType');
export const SET_PRIMARY_DIMENSION = type('SetPrimaryDimension');
export const SET_SECONDARY_DIMENSION = type('SetSecondaryDimension');
export const SET_MEASURE = type('SetMeasure');

export const SET_TABLE_CUBE_DATE_FILTER = type('SetTableCubeDateFilter');
export const SET_TABLE_CUBE_WAREHOUSE_FILTER = type('SetTableCubeWarehouseFilter');
export const SET_TABLE_CUBE_USER_FILTER = type('SetTableCubeUserFilter');
export const SET_TABLE_CUBE_TABLE_FILTER = type('SetTableCubeTableFilter');
export const SET_TABLE_CUBE_ACCESS_TYPE_FILTER = type('SetTableCubeAccessTypeFilter');
export const SET_TABLE_CUBE_DATE_FILTER_AND_BIN = type('SetTableCubeDateFilterAndBin');
export const COPY_FILTER_VALUES = type('CopyFilterValues');
export const SELECT_CHART_AREA = type('SelectChartArea');
export const SELECT_DASHBOARD_CHART_AREA = type('SelectDashboardChartArea');
export const RESET_TABLE_CUBE_FILTERS = type('ResetRableCubeFilters');

export const SELECT_TAB = type('SelectTab');

export const CREATE_EXPLORE = type('CreateExplore');
export const GET_EVENTS_TABLE_COLUMNS = apiType('GetEventsTableColumns');
